// extracted by mini-css-extract-plugin
module.exports = {"ticketList":"TicketList_ticketList__3ntKD","slide-in-right":"TicketList_slide-in-right__2fEia","slide-out-right":"TicketList_slide-out-right__3Ts57"};